import React from "react";
import { Route, Switch } from "react-router-dom";
// import Inbox from "./inbox/index";
import List from "./list";
import ClientList from "./clientList";
import "./index.css";
const Production = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/:clientId/client`} component={List} />
      <Route path={`${match.url}/:enquiryStatus`} component={List} />
      {/* <Route path={`${match.url}`} component={List} /> */}
    </Switch>
  );
};

export default Production;
